import { ImagePlusIcon, Paragraph } from '@buffer-mono/popcorn'

import { UploadSource } from '@buffer-mono/uploader'
import type { Uploader } from '@buffer-mono/uploader'

import * as UploadDropzone from '~publish/components/UploadDropzone'

import { useFilePicker } from '../hooks/useFilePicker'

import styles from './AddMediaButton.module.css'

import type { JSX } from 'react'

/**
 * Bordered add-media tile for the thumbnail grid. Click opens the file
 * picker; dragging files over it drops them onto the uploader.
 */
export const AddMediaButton = ({
  uploader,
}: {
  uploader: Uploader
}): JSX.Element => {
  const { open, inputProps } = useFilePicker({ uploader, multiple: true })

  const handleDrop = (files: File[]): void => {
    if (files.length > 0) {
      uploader.addFiles(files, { source: UploadSource.dragAndDrop() })
    }
  }

  return (
    <UploadDropzone.Root className={styles.root} onDrop={handleDrop}>
      <button
        type="button"
        className={styles.button}
        onClick={open}
        aria-label="Attach file"
        data-testid="composer-uploader-dropzone"
      >
        <ImagePlusIcon size="medium" color="subtle" />

        <Paragraph size="sm" color="subtle" align="center">
          Drag &amp; drop or{' '}
          <span className={styles.action}>select a file</span>
        </Paragraph>
      </button>

      <input {...inputProps} data-testid="uploads-dropzone-input" />
    </UploadDropzone.Root>
  )
}
